import Fieldset from "components/form/Fieldset";
import FormContent from "components/form/FormContent";
import FormRow from "components/form/FormRow";
import TextInput from "components/form/input/TextInput";

export default function ApontamentoResultado({ conformidadeLabel = "Conformidade (%)", showConformidadeField = true, children }) {
    return (
        <Fieldset label="Resultado da Amostra" fullWidth>
            <FormContent>
                <FormRow>
                    {showConformidadeField && (
                        <TextInput
                            sx={{ "& input": { fontWeight: "bold" } }}
                            name="conformidade"
                            label={conformidadeLabel}
                            disabled
                        />
                    )}
                </FormRow>

                {children}
            </FormContent>
        </Fieldset>
    );
}
